/** Returns whether plan restrictions disable the profile at the given list index. */
export const getProfileIsDisabled = (isProfileAllowBasicUpsell, profileLimit, index) => {
  // profile should be disabled if the index is greater than profileLimit
  const isProfileDisabled = isProfileAllowBasicUpsell && index > (profileLimit - 1)

  return isProfileDisabled
}
